import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=a9235ae0&scoped=true&"
import script from "./ButtonDelete.vue?vue&type=script&lang=js&"
export * from "./ButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDelete.vue?vue&type=style&index=0&id=a9235ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9235ae0",
  null
  
)

export default component.exports